import { render } from "./MobileTabBar.vue?vue&type=template&id=408da88e&scoped=true"
import script from "./MobileTabBar.vue?vue&type=script&lang=js"
export * from "./MobileTabBar.vue?vue&type=script&lang=js"

import "./MobileTabBar.vue?vue&type=style&index=0&id=408da88e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408da88e"]])

export default __exports__